import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { OffsetTopOne, OffsetTopThree, OffsetTopTwo } from "../../component/body/body";
import { color, themeType, typo } from '../../styles/style';
import ImgAtom from '../atoms/ImgAtom';
import TextAtom from '../atoms/TextAtom';
import TextLineAtom from '../atoms/TextLineAtom';
import TextMarginAtom from '../atoms/TextMarginAtom';



/* eslint no-restricted-globals: ["off"] */

const FooterBoxOuter = styled.div`
  display: flex;
  width: 90%;
  border-radius: 0 50px 0 0;
  background: #0c0c0c;
  height: 100%;
  justify-content: flex-end;
  padding-bottom: 85px;
  ${({ theme }) => theme.media.tablet`
  width: 100%;
  border-radius: 0px;
  justify-content: center;
    `}
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  border-radius: 0px;
  justify-content: center;
    `}
`;
const FooterBox = styled.div`
  display: flex;
  width: 88.8%;
  height: 100%;
  justify-content: flex-start;
  ${({ theme }) => theme.media.tablet`
  width: 80%;
  justify-content: center;
    `}
  ${({ theme }) => theme.media.mobile`
  width: 100%;
  justify-content: center;
  flex-direction: column;
    `}
`;
const FooterLeft = styled.div`
  display: flex;
  width: 40%;
  height: 80%;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
    width: 100%;
    align-items: center;
    `}
`;
const FooterCenter = styled.div`
  width: 20%;
  height: auto;
  color: #374553;
  font-size: 20px;
  font-weight: 400;
  line-height: 35px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 54px;
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    display: flex;
    `}
`;

const FooterRight = styled.div`
  width: 20%;
  height: auto;
  color: #374553;
  font-size: 20px;
  font-weight: 400;
  line-height: 35px;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 54px;
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    display: flex;
    `}
`;


function OffsetTop () {
  window.scroll({
    behavior: "smooth",
    top: 0,
  });
}


function MoveNextUnicorn () {
  location.href='https://www.nextunicorn.kr/company/7826c0a94c02e8eb'
}

function MoveRocketpunch () {
    location.href='https://www.rocketpunch.com/companies/lab254'
}

function MoveGithub () {
  location.href='https://github.com/LAB254-dev'
}

class FooterMolecule extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }


  render() {


    return (
      <FooterBoxOuter>
        <FooterBox>
          <FooterLeft >
            <ImgAtom
              src="./images/footer_logo.png"
              imgwidth="119px"
              onClick = {OffsetTop}
              cursor= "pointer"
            />
            <TextAtom
              text="LAB254 - All Right Reserved"
              typo={typo.footer.f1}
              color={color(themeType.light).text.placeholder}
              margin="140px 0 0 0 "
              marginM="0"
            />
          </FooterLeft>
          <FooterCenter>
            <TextLineAtom id="li-navi"
              text="LAB254"
              typo={typo.footer.f2}
              color={color(themeType.light).text.primary}
              onClick = {OffsetTop}
            />
            <TextMarginAtom id="li-navi"
              text="Team"
              typo={typo.footer.f3}
              color={color(themeType.light).text.primary}
              onClick = {OffsetTopOne}
            />
            <TextMarginAtom id="li-navi"
              text="Project"
              typo={typo.footer.f3}
              color={color(themeType.light).text.primary}
              onClick = {OffsetTopTwo}
            />
            <TextMarginAtom id="li-navi"
              text="Contact"
              typo={typo.footer.f3}
              color={color(themeType.light).text.primary}
              onClick = {OffsetTopThree}
            />
          </FooterCenter>
          <FooterRight>
            <TextLineAtom
              text="FOLLOW US"
              typo={typo.footer.f2}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="넥스트유니콘"
              typo={typo.footer.f3}
              onClick={MoveNextUnicorn}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="The VC"
              typo={typo.footer.f3}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="로켓펀치"
              typo={typo.footer.f3}
              onClick = {MoveRocketpunch}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="Github"
              typo={typo.footer.f3}
              onClick = {MoveGithub}
              color={color(themeType.light).text.primary}
            />
          </FooterRight>
        </FooterBox>
      </FooterBoxOuter>
    );
  }
}

export default FooterMolecule;